import axios from "axios";
import { SERVER_API_URL } from "../constants/constants";
const config = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, timeout: 30000 });
export const getWebsiteContent = async () => (await axios.get(`${SERVER_API_URL}/admin/app_settings/website`, config())).data;
export const saveWebsiteContent = async (content) => (await axios.put(`${SERVER_API_URL}/admin/app_settings/website`, content, config())).data;
export const uploadWebsiteImage = async (file) => {
  const form = new FormData(); form.append("image", file);
  return (await axios.post(`${SERVER_API_URL}/admin/app_settings/website/image`, form, { ...config(), timeout: 60000 })).data;
};
